import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  hitSentenceResolver,
  sentenceAllTagsResolver,
  sentenceInfosResolver,
  sentenceKeysResolver,
  sentenceMetaTagsResolver,
  sentencesResolver,
  sentenceUserTagsResolver
} from './sentence'

const streamDataFieldResolvers: FieldResolver[] = [
  hitSentenceResolver,
  sentenceAllTagsResolver,
  sentenceInfosResolver,
  sentenceKeysResolver,
  sentenceMetaTagsResolver,
  sentencesResolver,
  sentenceUserTagsResolver
]

const sentenceRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  if (metadata.isDeleted()) {
    return { sentenceMetaTags: [] as string[], sentenceUserTags: [] as string[] } as StreamData
  }

  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default sentenceRelatedFieldsResolver
